import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const containerVariants = cva('mx-auto w-full px-6 sm:px-8', {
  variants: {
    size: {
      sm: 'max-w-2xl',
      md: 'max-w-4xl',
      lg: 'max-w-6xl',
      xl: 'max-w-[80rem]',
      prose: 'max-w-[45rem]',
      full: 'max-w-none',
    },
  },
  defaultVariants: {
    size: 'lg',
  },
});

interface ContainerProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof containerVariants> {
  ref?: React.Ref<HTMLDivElement>;
}

export function Container({ className, size, ref, ...props }: ContainerProps) {
  return <div ref={ref} className={cn(containerVariants({ size }), className)} {...props} />;
}
